import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Turnstile from 'react-turnstile'; 
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../App.css'; 

const TURNSTILE_SITE_KEY = "0x4AAAAAACCbYFvRrIy4ZORU"; 

function SignupPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [companyName, setCompanyName] = useState(''); 
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null); 
  
  const [isSuccess, setIsSuccess] = useState(false); 

  const { signup } = useAuth(); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!captchaToken) { setError("Please complete the security check."); return; }
    if (password !== confirmPassword) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters long."); return; }

    setLoading(true);

    try {
      const success = await signup(email, password, companyName, captchaToken);
      
      if (success) {
        setIsSuccess(true); 
      } else {
        setError('Failed to create account. Email might already be in use.');
      }
    } catch (err) {
      setError('An unexpected error occurred.');
    } finally {
      setLoading(false);
    }
  };

  return (
    /* 1. FIXED: Flex container makes the footer sticky */
    <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      
      {/* 2. FIXED: 'flex: 1' makes this section expand to fill empty space */ }
      <header className="App-header" style={{ 
          display: 'flex', 
          flexDirection: 'column',       
          alignItems: 'center',          
          justifyContent: 'flex-start',  
          paddingTop: '60px',            
          flex: 1, // <--- This is the magic key. It fills the vertical space.
          width: '100%'                  
      }}>
        
        {isSuccess ? (
            <div className="form-container" style={{textAlign: 'center', maxWidth: '500px', padding: '40px'}}>
                <div style={{fontSize: '3rem', marginBottom: '15px'}}>📧</div>
                <h2 style={{marginBottom: '10px'}}>Verify your email</h2>
                <p style={{fontSize: '1.1rem', color: '#555', lineHeight: '1.5'}}>
                    We've sent a verification link to <strong>{email}</strong>.
                    <br/>Please check your inbox <strong>(and Spam folder)</strong> to activate your account.
                </p>
                <div style={{marginTop: '30px', fontSize: '0.9rem'}}>
                    <Link to="/login" className="generate-button" style={{textDecoration: 'none', display: 'inline-block', width: 'auto', padding: '10px 25px'}}>
                        Go to Login
                    </Link>
                </div>
            </div>
        ) : (
            <form className="form-container login-form" onSubmit={handleSubmit} style={{maxWidth: '450px', width: '100%'}}>
            <h2 style={{textAlign: 'center', marginBottom: '30px'}}>Create Account</h2>
            
            {error && <p className="error-message">{error}</p>}

            <div className="form-group">
              <label htmlFor="company">Company Name</label> 
              <input 
                type="text" 
                id="company"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                placeholder="e.g. Acme Corp"
                required 
              />
            </div>

            <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" required />
            </div>
            
            <div className="form-group">
                <label htmlFor="password">Password</label>
                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create a password (min 8 chars)" required />
            </div>

            <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Re-enter your password" required />
            </div>

            <div style={{marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center'}}>
                <Turnstile sitekey={TURNSTILE_SITE_KEY} onVerify={(token) => setCaptchaToken(token)} theme="light" />
            </div>

            <button type="submit" className="generate-button" disabled={loading || !captchaToken} style={{marginTop: '10px'}}>
                {loading ? 'Creating Account...' : 'Sign Up'}
            </button>
            
            <div style={{marginTop: '20px', textAlign: 'center', fontSize: '0.9rem', color: '#42526e'}}>
                Already have an account? <Link to="/login" style={{color: '#0052cc', fontWeight: '600', textDecoration: 'none'}}>Log In</Link>
            </div>
            </form>
        )}
      </header>
      <Footer />
    </div>
  );
}

export default SignupPage;